import { KeyboardEvent } from "react";

export const useKeyDownAsClick = (callback: () => void) => {
  return (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      callback();
    }
  };
};
